var _isSound = false;
//preload
import {preload} from "./include/module";
preload();

//toggleHeader
import {toggleHeader} from "./include/module";
toggleHeader();

//pageTop
import {pageTop} from "./include/module";
pageTop();

//showMovie
import {showMovie} from "./include/module";
showMovie();

//tabSwitching
// import {tabSwitching} from "../include/module";
// tabSwitching();

//anchorLink
import {anchorLink} from "./include/module";
anchorLink();

//soundPlay
import {soundPlay} from "./include/module";

//soundStop
import {soundStop} from "./include/module";

//soundPause
import {soundPause} from "./include/module";

//soundCommon
import {soundCommon} from "./include/module";
soundCommon();


//showItem
import {showItem} from "./include/module";
showItem();



// WEBPACK FOOTER //
// ./src/assets/js/script.js